import React from 'react';
import SalesLetterWrapper from './SalesLetterWrapper';
import SafeIcon from '../common/SafeIcon';
import { FiXCircle } from 'react-icons/fi';

const TheProblemLetter = () => {
  return (
    <SalesLetterWrapper alt={true} className="border-y border-slate-200">
      <div className="space-y-8">
        <h2 className="text-3xl md:text-5xl font-display font-black text-brand-dark text-center mb-12">
          The Problem Is…
        </h2>

        <p className="text-center font-bold">Most “make money online” advice feels:</p>
        
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {['overwhelming', 'risky', 'technical', 'expensive', 'or unrealistic'].map((word, i) => (
            <span key={i} className="px-4 py-2 bg-white text-red-600 rounded-xl border border-red-100 shadow-sm font-bold">{word}</span>
          ))}
        </div>

        <p>Everywhere you look online, someone is promoting:</p>
        
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 list-none p-0">
          {[
            'crypto', 'dropshipping', 'Amazon FBA', 
            'expensive coaching', '“passive income empires”', 
            'or complicated systems requiring endless learning'
          ].map((item, i) => (
            <li key={i} className="bg-white/50 p-4 rounded-xl flex items-center gap-3 border border-slate-200">
              <SafeIcon icon={FiXCircle} className="text-red-400" />
              <span className="text-sm font-medium">{item}</span>
            </li>
          ))}
        </ul>

        <div className="pt-12 text-center space-y-8">
          <p className="text-2xl text-text-secondary italic">For many retirees… That world feels exhausting.</p>
          
          <h3 className="text-3xl font-display font-black text-brand-dark">
            And honestly?<br/>
            <span className="text-brand-gold underline decoration-brand-gold/20">Most retirees don’t WANT another stressful full-time career.</span>
          </h3>

          <div className="bg-brand-green text-white p-12 rounded-[3rem] shadow-2xl">
            <p className="text-2xl font-light mb-4">They simply want:</p>
            <p className="text-3xl md:text-4xl font-black">safe, flexible, beginner-friendly ways to earn extra income online.</p>
          </div>
          
          <p className="text-xl font-black uppercase tracking-widest text-brand-dark pt-8">
            That’s exactly why this program was created.
          </p>
        </div>
      </div>
    </SalesLetterWrapper>
  );
};

export default TheProblemLetter;